import { render } from "./SlideWrapperElements.vue?vue&type=template&id=23d6c870&scoped=true"
import script from "./SlideWrapperElements.vue?vue&type=script&lang=js"
export * from "./SlideWrapperElements.vue?vue&type=script&lang=js"

import "./SlideWrapperElements.vue?vue&type=style&index=0&id=23d6c870&scoped=true&lang=scss"
import "./SlideWrapperElements.vue?vue&type=style&index=1&id=23d6c870&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23d6c870"]])

export default __exports__